export default {
  body: "Archivo, sans-serif",
  heading: "Archivo, sans-serif",
  action: "Open Sans, sans-serif",
  mono: "Roboto Mono, monospace",
};
